import { Button } from "components/DesignSystem/Button/Button";

type PlanCardButtonProps = {
  type?: string;
  isActive?: boolean;
  buttonType?: "primary_outlined" | "secondary";
  onUpgrade?: () => void;
  isButtonDisabled?: boolean;
  buttonText?: string;
  hideUpgrade?: boolean;
  onDowngrade?: () => void;
  isLoading?: boolean;
  isAddToCartFlow?: boolean;
  handleAddToCart?: () => void;
};

export const PlanCardButton = ({
  type,
  isActive,
  buttonType,
  onUpgrade,
  isButtonDisabled,
  buttonText,
  hideUpgrade,
  onDowngrade,
  isLoading,
  isAddToCartFlow,
  handleAddToCart,
}: PlanCardButtonProps) => {
  const isFreePlanInactive = type === "Free" && !isActive;

  if (isFreePlanInactive && onDowngrade) {
    return (
      <Button customType={buttonType} onClick={onDowngrade} size="small">
        Downgrade
      </Button>
    );
  }

  if (isAddToCartFlow) {
    return (
      <Button
        customType="primary_outlined"
        size="small"
        onClick={handleAddToCart}
        disabled={isButtonDisabled || isLoading}
        isLoading={isLoading}
      >
        Add to cart
      </Button>
    );
  }
  if (!hideUpgrade) {
    return (
      <Button
        customType={buttonType}
        disabled={isButtonDisabled || isLoading}
        onClick={onUpgrade}
        size="small"
        isLoading={isLoading}
      >
        {buttonText}
      </Button>
    );
  }

  return null;
};
